import React from "react";
import "./ResearchandDevelopment.css";
import Navbar from "../components/Navbar";

const ResearchandDevelopment = () => {
  return (
    <>
      <Navbar />
      <div className="randd-container">
        <div className="randd-content">
          <p className="randd-content-para">Research & Innovation / Corporate R&D Programs</p>
           <h2>Corporate R&D Programs</h2>
          <p className="subtitle12">
            Solving complex industrial challenges using XR, AI, and Spatial Computing.
          </p>
          <p>
            We collaborate with industry leaders to drive innovations across product development, safety, and smart operations.
          </p>

          <div className="randd-grid">
            <div className="randd-row">
              <div className="randd-box">
                <h4>Virtual Prototyping & Simulation</h4>
                <p>
                  Using XR for rapid prototyping, ergonomic validation, and user feedback before physical production.
                </p>
                <p><strong>Ideal for:</strong> Automotive, aerospace, consumer goods R&D</p>
              </div>

              <div className="randd-box">
                <h4>Spatial Dashboards & Smart Control Rooms</h4>
                <p>
                  Developing XR-powered dashboards for real-time data visualization, operational insights, and decision-making.
                </p>
                <p><strong>Ideal for:</strong> Manufacturing, energy, utilities</p>
              </div>
            </div>

            <div className="randd-row">
              <div className="randd-box">
                <h4>Immersive Remote Collaboration</h4>
                <p>
                  Creating multi-user XR platforms for distributed teams to co-design, simulate, and test in shared virtual spaces.
                </p>
                <p><strong>Ideal for:</strong> Innovation labs, global design teams, R&D teams</p>
              </div>

              <div className="randd-box">
                <h4>XR Safety Labs & Human Factor Analysis</h4>
                <p>
                  Building virtual labs to simulate risk scenarios, analyze human behavior, and enhance safety training.
                </p>
                <p><strong>Ideal for:</strong> Safety and compliance teams, HRD labs, training innovation groups</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}; 
export default ResearchandDevelopment;
